import AppAcquisitionDataVisible from '../components/app/AppAcquisitionDataVisible.vue'
import CohortPanel from '../components/app/CohortPanel.vue'

import { DashboardChartArea } from '@/features/dashboards'
import type { ReportFilter, ReportLayoutConfig, SectionBuild } from '@/features/reports'

const APP_ACQUISITION_REPORT_ID = 6
const PLATFORM_TAB_FILTERS: Record<string, ReportFilter[]> = {
  'App Store': [{ field: 'store_type', match_mode: 'in', value: ['ios', 'iOS', 'app_store'] }],
  'Google Play': [
    { field: 'store_type', match_mode: 'in', value: ['android', 'Android', 'google_play'] },
  ],
  Windows: [{ field: 'store_type', match_mode: 'equals', value: 'microsoft_store' }],
  Other: [{ field: 'store_type', match_mode: 'equals', value: 'unknown' }],
}

const platformBreakdownBuild: SectionBuild = ({ tab }) => ({
  id: `18-platform-breakdown-${tab.name}`,
  reportId: APP_ACQUISITION_REPORT_ID,
  scheduleTabs: ['metrics_mmp_campaign'],
  sortField: 'mmp_app_installs',
  filters: PLATFORM_TAB_FILTERS[tab.name] ?? [],
})

const acquisitionOverviewBuild: SectionBuild = () => ({
  id: '18-overview',
  reportId: APP_ACQUISITION_REPORT_ID,
  scheduleTabs: ['metrics_mmp_campaign'],
  view: 'chart',
  allowedViews: ['table', 'chart'],
  chartType: 'pie',
  chartDimensions: ['channel_name'],
  chartMetrics: ['mmp_cost', 'mmp_revenue', 'mmp_app_installs'],
})

// v3 `dashboardConfig` → module 09 `DashboardChartArea`.
const acquisitionTrendlineBuild: SectionBuild = () => ({
  id: '18-app-acquisition',
  reportId: APP_ACQUISITION_REPORT_ID,
  scheduleTabs: ['metrics_mmp_campaign'],
})

export const APP_ACQUISITION: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'commerceAnalytics.appAcquisition.tabs.overview',
    sections: [
      {
        id: '18_app_acquisition',
        reportId: APP_ACQUISITION_REPORT_ID,
        hideChannels: true,
        renderer: DashboardChartArea,
        rendererMode: 'replace',
        rendererProps: {
          defaultMetricFields: ['mmp_cost', 'mmp_revenue', 'mmp_app_installs'],
        },
        build: acquisitionTrendlineBuild,
        tabs: [{ name: 'Performance Trendline', tabs: ['metrics_mmp_campaign'] }],
      },
      {
        id: '18-overview',
        titleKey: 'commerceAnalytics.appAcquisition.overview.title',
        reportId: APP_ACQUISITION_REPORT_ID,
        showDatePicker: true,
        hideChannels: true,
        renderer: AppAcquisitionDataVisible,
        rendererMode: 'replace',
        build: acquisitionOverviewBuild,
        tabs: [{ name: 'Overview', tabs: ['metrics_mmp_campaign'] }],
      },
      // v3 `AppAcquisitionCohortArea` section: its own chrome (title, platform rail, controls).
      {
        id: '18-cohort-retention',
        reportId: 18,
        hideChannels: true,
        component: CohortPanel,
        tabs: [{ name: 'Overview', tabs: ['week', 'month'] }],
      },
      {
        id: '18-platform-breakdown',
        titleKey: 'commerceAnalytics.appAcquisition.platformBreakdown.title',
        reportId: APP_ACQUISITION_REPORT_ID,
        showDatePicker: true,
        build: platformBreakdownBuild,
        tabs: [
          { name: 'Overall', tabs: ['metrics_mmp_campaign'] },
          {
            name: 'App Store',
            checkDimension: { field: 'store_type', value: ['ios', 'iOS', 'app_store'] },
            tabs: ['metrics_mmp_campaign'],
          },
          {
            name: 'Google Play',
            checkDimension: { field: 'store_type', value: ['android', 'Android', 'google_play'] },
            tabs: ['metrics_mmp_campaign'],
          },
          {
            name: 'Windows',
            checkDimension: { field: 'store_type', value: ['microsoft_store'] },
            tabs: ['metrics_mmp_campaign'],
          },
          {
            name: 'Other',
            checkDimension: { field: 'store_type', value: ['unknown'] },
            tabs: ['metrics_mmp_campaign'],
          },
        ],
      },
    ],
  },
]
